module.exports = __webpack_public_path__ + "static/media/what_right.9a8cafec.png";